import React, { Component, Fragment } from 'react'
import { langCheck } from 'Pub/js/utils';

export default function BatchSelection(props) {
	return (
		<Fragment>
			<li onClick={props.checkAllCard}>
				{/*批量全选*/}
				{langCheck('ZoneSetting-000268', 'pages', props.json)}
			</li>
			<li onClick={props.showCheckbox}>
				{/*批量选择*/}
				{langCheck('ZoneSetting-000269', 'pages', props.json)}
			</li>
		</Fragment>
	)
}
